import { useMemo, useRef, useState } from "react";
import { handleInput, handleReset } from "../../Common/Util";
import { Col, Row } from "react-bootstrap";
import { DateTime, Input, LocationCoordinates, Message, SubmitClearButton, Timezone } from "../../Client/ClientUtil";
import { validateCity, validateDouble } from "../../Client/ClientValidate";
import validator from "validator";
import { axiosErrorHandler, axiosPostWithHeader, ShowAlertError } from "../../Common/axios";

export function OptionsChart () {
  const [errorAlert, setErrorAlert] = useState(null);
  const [message, setMessage] = useState('');
  const [optionCount, setOptionCount] = useState('2');
  const [optionDate, setOptionDate] = useState('');
  const [optionTime, setOptionTime] = useState('');
  const [optionTimezone, setOptionTimezone] = useState('5.5');
  const [optionCity, setOptionCity] = useState('');
  const [optionLongitude, setOptionLongitude] = useState('');
  const [optionLatitude, setOptionLatitude] = useState('');
  const [optionResult, setOptionResult] = useState('');

  const optionCountReference = useRef();
  const optionDateReference = useRef();
  const optionTimeReference = useRef();
  const optionCityReference = useRef();
  const optionLongitudeReference = useRef();
  const optionLatitudeReference = useRef();
    

  useMemo(() => {
  },[])

  const setMethod = { 
    setOptionCount, setOptionDate, setOptionTime, setOptionTimezone, setOptionCity,
    setOptionLongitude, setOptionLatitude, setOptionResult, setMessage };

  const handleLocationInput = (name, value) => {
      switch(name) {
        case 'optionLongitude': setOptionLongitude(value); break;
        case 'optionLatitude': setOptionLatitude(value); break;
        default : 
      }
  }

  const customhandleReset = (setMethod,ref) =>{
      handleReset(setMethod,ref);
      setOptionCount('2');
      setOptionTimezone('5.5');
  }  

  const handleSubmit =  (event) => {
    var msg = '';
    if(optionCount===null|| optionCount===undefined || !validator.isInt(optionCount.trim()) || optionCount.length>2 || optionCount.length<1
      || optionCount.trim().indexOf('-')!==-1 || optionCount.trim().indexOf('+')!==-1
      || optionCount.trim()<=0 || optionCount.trim()>20) {
      msg="Enter valid number. min: 1, max: 20";
      optionCountReference.current.focus();
      event.preventDefault();
    }
    if(msg==='' && optionDate==="" ) {
        msg="Enter date";
        optionDateReference.current.focus();
        event.preventDefault();
    }
    if(msg==='' && optionTime==="" ) {
      msg="Enter time";
      optionTimeReference.current.focus();
      event.preventDefault();
    }
    if(msg==='') msg = validateCity(event,"place name",optionCityReference,optionCity);
    if(msg==='') msg = validateDouble(event,"latitude",optionLatitudeReference,optionLatitude,-90,90);
    if(msg==='') msg = validateDouble(event,"longitude",optionLongitudeReference,optionLongitude,-180,180);
    setMessage(msg); 
    if(msg==='') {
      const requestData = {
        optionsCount: optionCount,
        date: optionDate,
        time: (optionTime.length===5?optionTime:optionTime.substring(0,5)),
        timezone: optionTimezone,
        place: optionCity,
        longitude: optionLongitude,
        latitude: optionLatitude,
      }

      axiosPostWithHeader("/chart/options", requestData,
          (response)=>{
            setOptionResult(response.data.result);
            setTimeout(() => {
              setOptionResult('');
            }, 60000);
          },
          (error)=>{
              setMessage(axiosErrorHandler(optionCountReference,error));
              setErrorAlert(error.message);
          }
      );
      
    }
    event.preventDefault();
  }

  return(
    <>
    <table class="m-0 p-0 table">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-1 pb-1">Options Theory</h4></caption>
    </table>
    <form onSubmit={handleSubmit}>
    <Row id="OptionsChart" className="m-0 p-0">
        <div class="col-sm-1 col-md-1 d-none d-md-block"></div> 
        <Col xs={12} lg={4} className="m-0 p-0 pt-0">
          <Message msg={message} />
          <Input name="optionCount" title="Number of Options" data={optionCount} reference={optionCountReference} callback={(event)=>handleInput(event,setMethod)} />
          <Timezone name="optionTimezone" data={optionTimezone} callback={(event)=>handleInput(event,setMethod)} />
          <DateTime title1="Date * " title2="Time * " dateplaceholder="Date" timeplaceholder="Time" 
            datename="optionDate" timename="optionTime" 
            datereference={optionDateReference} timereference={optionTimeReference} 
            datevalue={optionDate} timevalue={optionTime} callback={(event)=>handleInput(event,setMethod)} />
          <LocationCoordinates 
                cityname="optionCity" citytitle="Place * " cityreference={optionCityReference} cityvalue={optionCity}
                coordinatesname="location" coordinatestitle="Location (Latitude, Longitude) * "
                longitudename="optionLongitude" latitudename="optionLatitude" 
                longitudereference={optionLongitudeReference} latitudereference={optionLatitudeReference} 
                longitudevalue={optionLongitude} latitudevalue={optionLatitude} 
                callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
        </Col>
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div> 
        <Col xs={12} lg={4} className="m-0 p-0 pt-0 text-center align-middle">
        {optionResult===''?<></>:
        <>
          <h2>Option Choice</h2>
          <h1 class="display-2 fw-bold">{optionResult}</h1>
        </>
        }
        </Col>
        <div class="col-sm-1 col-md-1 d-none d-md-block"></div> 
    </Row>
    <Row id="OptionsChart1" className="m-0 p-0">
      <Col xs={12} className="m-0 p-0 pt-0">
        <SubmitClearButton callback={()=>customhandleReset(setMethod,optionCountReference)} /> 
      </Col>
    </Row>
    </form>
    <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>    
    </>
  );
}

